import React from 'react';
import { Box, Select } from '@spothero/ui';
import { SPOT_SORT_OPTIONS } from 'utils/spot-sort';
import { useDispatch, useSelector } from 'react-redux';
import { setSortType } from 'store/search/search-actions';
import { useClearFocus } from 'pages/search/hooks/use-clear-focus';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
export const FilterSpotSort = () => {
    const { clearFocus } = useClearFocus();
    const dispatch = useDispatch();
    const sortSelectItems = [
        {
            value: SPOT_SORT_OPTIONS.RELEVANCE,
            label: 'Sort: Relevance',
        },
        { value: SPOT_SORT_OPTIONS.DISTANCE, label: 'Sort: Distance' },
        { value: SPOT_SORT_OPTIONS.PRICE, label: 'Sort: Price' },
    ];
    const show = useMobileBreakPoint();
    const sortBy = useSelector((state) => state.search.data.sortBy);
    const onChangeSort = ({ target }) => {
        const { value } = target;
        clearFocus();
        dispatch(setSortType(value));
    };
    if (!show) {
        return null;
    }
    return (<Box minWidth="max-content" sx={{
            '& .chakra-select': {
                paddingLeft: 2,
                paddingRight: 8,
                fontSize: 'xs',
                fontWeight: 'medium',
                _hover: {
                    borderColor: 'black',
                },
            },
        }}>
            <Select value={sortBy} onChange={onChangeSort} data-testid="SpotListSorter-select" key={sortBy}>
                {sortSelectItems.map(({ label, value }) => (<option value={value} key={value} data-testid={`SpotListSorter-select-${value}`}>
                        {label}
                    </option>))}
            </Select>
        </Box>);
};
